"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.freezeCart = exports.reopenCart = exports.removeLoyalty = exports.addLoyalty = exports.deleteCart = exports.defrostCart = exports.cancelRecoverCart = exports.recoverCart = exports.getCartHash = exports.removeItemFromCart = exports.addItemToCart = exports.getCart = void 0;
const axios_1 = __importDefault(require("axios"));
const defaultCartType = 'fs';
const proxy = axios_1.default.create({ baseURL: '/api/cartproxy/v1' });
const v3proxy = axios_1.default.create({ baseURL: '/api/cartproxy/v3' });
const cart = axios_1.default.create({ baseURL: '/api/cartproxy/orderpiper/cart/v3' });
const getCart = () => proxy.get('');
exports.getCart = getCart;
const addItemToCart = (productItem, cartType, ctx) => {
    let data = {};
    if (ctx) {
        data = Object.assign(Object.assign({}, data), { context: Object.assign({ sale_id: ctx.saleId, origin: ctx.origin }, (ctx.bundleId ? { bundle_id: ctx.bundleId } : {})) });
    }
    if (Array.isArray(productItem)) {
        data = Object.assign(Object.assign({}, data), { products_quantity: productItem.map((item) => ({
                product_id: item.productId,
                quantity: item.quantity,
            })), cart_type: cartType || defaultCartType });
        return proxy.post('/items', data);
    }
    else {
        data = Object.assign(Object.assign({}, data), { product_id: productItem.productId, cart_type: cartType || defaultCartType, quantity: productItem.quantity });
        return proxy.post('/item', data);
    }
};
exports.addItemToCart = addItemToCart;
const removeItemFromCart = (productId, cartType) => proxy.delete('/item', { data: { product_id: productId, cart_type: cartType || defaultCartType } });
exports.removeItemFromCart = removeItemFromCart;
const deleteCart = () => proxy.delete('');
exports.deleteCart = deleteCart;
const reopenCart = (productId, quantity, cartType, orderToReopen = null) => proxy.post('/item', {
    product_id: String(productId),
    quantity,
    cart_type: cartType !== null && cartType !== void 0 ? cartType : defaultCartType,
    order_to_reopen: orderToReopen,
});
exports.reopenCart = reopenCart;
const getCartHash = () => cart.get('');
exports.getCartHash = getCartHash;
const freezeCart = (cartHash) => cart.post('/pay', { cartHash, generateDeeplinkReturnUrl: false });
exports.freezeCart = freezeCart;
const defrostCart = () => cart.post('/cancel-order').then(getCart);
exports.defrostCart = defrostCart;
const recoverCart = (dismissed) => cart.post('/recover', { dismissedProducts: dismissed }).then(getCart);
exports.recoverCart = recoverCart;
const cancelRecoverCart = () => cart.post('/cancel-recovery');
exports.cancelRecoverCart = cancelRecoverCart;
const addLoyalty = (productId) => v3proxy.post('/loyalty-item', { productId, quantity: 1 });
exports.addLoyalty = addLoyalty;
const removeLoyalty = (productId) => cart.delete('/item', { data: { productId, quantity: 1 } });
exports.removeLoyalty = removeLoyalty;
